import { CFImage } from '../../type/client-index'

export const Cover: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/b30a8d9e-265f-4dbf-f71d-a9ab87ba8c00/1500',
  width: 867,
  height: 1455
}

export const BettyJeaneProfile: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/cfd1237f-367f-4722-f46b-70d1daa38a00/1500',
  width: 1160,
  height: 1459
}

export const Before: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/f097fa3e-ec9b-4fcd-823a-d06e6b7f3b00/1750',
  width: 808,
  height: 1750
}

export const After: CFImage = {
  url: 'https://imagedelivery.net/srkYgDd5YoRrGjuibYE5kw/ce642c34-0c19-4bdc-6e02-a9b724243600/1750',
  width: 808,
  height: 1750
}
